import React from 'react';
import "./styles/crawler.css"

interface Props {
    onClearCrawler: () => void;
}

export const Crawler = (props: Props) => {
    return (
        <div className="crawler" onClick={() => props.onClearCrawler()}>
            <p>
                <span className="header">EPISODE LIBURNICON 2021</span>
                <span className="header">Star trek vs. Star wars spacebattle</span>
                Odavno postoji borba izumeđu fanova Star trek i Star wars serijala.
                Mnogi su izgubili sate u raspravama, izgubili oklade, bogatstva, prijatelje.
                Polemike oko toga koji je bolji serijal još uvijek ne prestaju, nitko više nezna koji je stvarniji, kvalitetniji, razrađeniji...
                <br /><br />
                Došlo je vrijeme da se sve nedoumice stave na stranu!
                Vrijeme je da fanovi odluče jednom i zauvijek koji je serijal bolji.
                Vrijeme je za borbu naslova najboljeg serijala, a kako najbolje nego u epskoj borbi svemirskih brodova.
                <br /><br />
                Kako igramo?
                <br />
                <ul>
                    <li>Imamo nekoliko fakcija od kojih je svaka dala svoja 2 svemirska broda u borbu na 2 samo njima poznata bojna polja</li>
                    <li>Sva druga polja predstavljaju moguću poziciju neprijateljskih brodova</li>
                    <li>Unaprijed se nezna koje polje sadrži pitanje za koji serijal</li>
                    <li>Kada otvorimo polje prikzuje nam se svemirski brod iz pripadajućeg serijala</li>
                    <li>Odgovori li fakcija točno na pitanje bod se daje serijalu iz kojeg je bilo pitanje te puca phasorima na polje
                        <ul>
                            <li>POGODAK - na polju se nalazio protivnički brod i uništen je te će se prikazati ime fakcije uništenog broda</li>
                            <li>PROMAŠAJ - nije bilo broda na polju te će se prikazati samo prazan svemir</li>
                        </ul>
                    </li>
                    <li>Nakon neuspješnog odgovora na pitanje će na isto polje doći neko drugo pitanje, ali opet neznamo iz kojeg serijala</li>
                </ul>
                <br /><br />
                Kada samo jedna fakcija ostane živa na ploči znamo pobjednika kviza, ali znamo i koji je serijal najbolji... naravno ona koja ima naviše skupljenih bodova.
                <br /><br />
                Da li ćete samo ciljati druge fakcije ili ćete možda namjerno krivo odgovoriti na pitanje Vama manje omiljenog serijala kako bi vaš omiljeni ostao u prednosti... to je na Vama.
                <br /><br />
                <span className="header">Sretno !!!</span>
            </p>
        </div>
    );
}
